import React, { useEffect, useState } from 'react'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import Input from 'srcReact/components/common2/Input'
import Label from 'srcReact/components/common2/Label'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { commonActions } from 'srcReact/components'
import { mixrActions } from 'srcReact/Mixr/actions'
import parentStyles from '../../../CreateUpdateMixr/styles.module.scss'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import IconButton from 'srcReact/components/common2/IconButton'

function PricingItem({ count, handleClose, handleChange, pricingDetailWithError, pricingDetail, editMode }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [price, setPrice] = useState(pricingDetail ? pricingDetail.amount : '')
  const [categories, setCategories] = useState([])
  const [currencyList, setCurrencyList] = useState([])
  const [feesLink, setFeesLink] = useState({
    value: pricingDetail ? pricingDetail.link : '',
    hasError: false,
    errorMessage: ''
  })

  const [amountErrorMessage, setAmountErrorMessage] = useState('')
  const [otherCategError, setOtherCategError] = useState('')

  useEffect(() => {
    if (pricingDetailWithError) {
      const { amountError, currencyError, feesCategoryError, otherCategoryError } = pricingDetailWithError
      setAmountErrorMessage(amountError)
      setSelectedCurrecy({
        ...selectedCurrecy,
        errorMessage: currencyError,
        hasError: currencyError && currencyError.length > 0
      })
      setSelectedFeesCategory({
        ...selectedFeesCategory,
        errorMessage: feesCategoryError,
        hasError: feesCategoryError && feesCategoryError.length > 0
      })
      setOtherCategError(otherCategoryError)
    }
  }, [pricingDetailWithError])

  useEffect(() => {
    if (editMode && pricingDetail) {
      setPrice(pricingDetail.amount)
      if (pricingDetail.category_id == '8' && pricingDetail.category_other !== otherFeeCategory.value) {
        setOtherFeeCategory({
          ...otherFeeCategory,
          value: pricingDetail.category_other || pricingDetail.category
        })
      }

      if (pricingDetail.link !== feesLink.value) {
        setFeesLink({
          ...feesLink,
          value: pricingDetail.link
        })
      }

      const curr =
        currencyList &&
        currencyList.length > 0 &&
        currencyList.find((c) => {
          return c.id === pricingDetail.currency_code
        })

      if (curr) {
        setSelectedCurrecy({
          ...selectedCurrecy,
          value: curr
        })
      }
      const category =
        categories &&
        categories.length > 0 &&
        categories.find((c) => {
          return c.id == pricingDetail.category_id
        })
      if (category) {
        setSelectedFeesCategory({
          ...selectedFeesCategory,
          value: category
        })
      }
    }
  }, [pricingDetail, currencyList, categories])

  const {
    mixr: { feesCategories },
    common: { currencies }
  } = useSelector((state) => state)

  const [selectedCurrecy, setSelectedCurrecy] = useState({
    value: { id: '', label: t('global.select') },
    hasError: false,
    errorMessage: ''
  })
  const [selectedFeesCategory, setSelectedFeesCategory] = useState({
    value: { id: -1, label: t('global.select') },
    hasError: false,
    errorMessage: ''
  })
  const [otherFeeCategory, setOtherFeeCategory] = useState({
    value: pricingDetail && pricingDetail.category_id == '8' ? pricingDetail.category : '',
    hasError: false,
    errorMessage: ''
  })

  const [pricingObj, setPricingObj] = useState(pricingDetail)

  useEffect(() => {
    if (feesCategories && feesCategories.length === 0) {
      dispatch(mixrActions.getFeeCategories())
    }
    if (currencies && currencies.length === 0) {
      dispatch(commonActions.getCurrencyList(1))
    }
  }, [])

  useEffect(() => {
    const updated =
      feesCategories &&
      feesCategories.map((f) => {
        return {
          id: f.id,
          label: f.name
        }
      })
    if (updated) {
      setCategories([{ id: -1, label: t('global.select') }, ...updated])
    }
  }, [feesCategories])

  useEffect(() => {
    const updated =
      currencies &&
      currencies.map((c) => {
        return {
          id: c.code,
          label: `${c.code} (${c.name})`,
          symbol: c.symbol
        }
      })
    if (updated) {
      setCurrencyList([{ id: '', label: t('global.select') }, ...updated])
    }
  }, [currencies])

  const handlePriceChange = (e) => {
    setAmountErrorMessage('')
    const value = e.target.value
    setPrice(value)

    setPricingObj({
      ...pricingObj,
      amount: value
    })
  }
  const handleCurrencyChange = (curr) => {
    setSelectedCurrecy({
      ...selectedCurrecy,
      hasError: curr.id === '',
      errorMessage: curr.id === '' && t('event.create.clientErrors.currencyRequired'),
      value: curr
    })
    setPricingObj({
      ...pricingObj,
      currency_code: curr.id,
      currency_symbol: curr.symbol
    })
    let isValid = true
  }

  const handleFeesCategoryChange = (cate) => {
    setSelectedFeesCategory({
      ...selectedFeesCategory,
      hasError: cate.id === -1,
      errorMessage: cate.id === -1 && t('event.create.clientErrors.feesCategoryRequired'),
      value: cate
    })

    setPricingObj({
      ...pricingObj,
      category_id: cate.id,
      category_other: ''
    })
  }

  const handleOtherFeeCategoryChange = (e) => {
    const value = e.target.value
    setOtherFeeCategory({
      ...otherFeeCategory,
      value: value
    })
    setPricingObj({
      ...pricingObj,
      category_other: value
    })
  }

  const handleFeesLinkChange = (e) => {
    const value = e.target.value
    setFeesLink({
      value: value,
      hasError: false,
      errorMessage: ''
    })
    setPricingObj({
      ...pricingObj,
      link: value
    })
  }

  useEffect(() => {
    if (
      pricingObj &&
      ((pricingObj.amount > 0 && pricingObj.amount != pricingDetail.amount) ||
        (pricingObj.category_id > 0 && pricingObj.category_id != pricingDetail.category_id) ||
        (pricingObj.category_other &&
          pricingObj.category_other.length > 0 &&
          pricingObj.category_other != pricingDetail.category_other) ||
        (pricingObj.currency_code &&
          pricingObj.currency_code.length > 0 &&
          pricingObj.currency_code != pricingDetail.currency_code) ||
        pricingObj.link !== pricingDetail.link)
    ) {
      handleChange(pricingObj, count - 1)
    }
  }, [pricingObj])

  const handleLinkBlur = (e) => {
    const value = e.target.value
    if (value) {
      let isLinkValid = true
      const urlReg =
        /(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,63}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?/
      if (!urlReg.test(value)) {
        isLinkValid = false
      }
      setFeesLink({
        value: value,
        hasError: !isLinkValid,
        errorMessage: !isLinkValid ? t('event.create.clientErrors.invalidLink') : ''
      })
    }
  }
  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <IconButton iconName='close24' iconSize='large24' onClick={handleClose} className={styles.btnClose} />
      </div>

      <div className={styles.pricingForm}>
        <div className={styles.amountCurrContainer}>
          <Label ariaLabel={t('event.create.timing.price')}>{`${t('event.create.timing.price')} ${count}`}</Label>
          <div className={styles.amountContainer}>
            <Input
              size='small'
              type='number'
              min={1}
              value={price}
              onChange={handlePriceChange}
              className={styles.input}
            />
            {amountErrorMessage && amountErrorMessage.length > 0 && (
              <ErrorMessage text={amountErrorMessage} className={`${parentStyles.error}  ${styles.errorColumn}`} />
            )}
          </div>
          <div className={styles.currecyContainer}>
            <Dropdown1
              value={selectedCurrecy.value}
              onChange={handleCurrencyChange}
              options={currencyList}
              className={`${styles.currencyDropdown} `}
              isSearchable={true}
            />
            {selectedCurrecy.hasError && (
              <ErrorMessage
                text={selectedCurrecy.errorMessage}
                className={`${parentStyles.error} ${styles.errorColumn}`}
              />
            )}
          </div>
        </div>

        <div className={styles.priceCategoryContainer}>
          <div className={styles.priceCategories}>
            <Label ariaLabel={t('event.create.for')}>{t('event.create.for')}</Label>
            <div className={styles.innerPriceCategories}>
              <Dropdown1
                value={selectedFeesCategory.value}
                onChange={handleFeesCategoryChange}
                options={categories}
                className={styles.feeCategoryDropdown}
              />
              {selectedFeesCategory.hasError && (
                <ErrorMessage
                  text={selectedFeesCategory.errorMessage}
                  className={`${parentStyles.error} ${styles.errorColumn}`}
                />
              )}
            </div>
          </div>
          {selectedFeesCategory.value && selectedFeesCategory.value.id == 8 && (
            <div className={styles.otherCategory}>
              <Label className={styles.otherCategoryLabel} ariaLabel={t('event.create.timing.otherCategory')}>
                {t('event.create.timing.otherCategoryPlaceholder')}
              </Label>
              <Input
                onChange={handleOtherFeeCategoryChange}
                value={otherFeeCategory.value}
                className={styles.otherCategoryInput}
                placeholder={t('event.create.timing.otherCategory')}
              />
              {otherCategError && otherCategError.length > 0 && (
                <ErrorMessage text={otherCategError} className={`${parentStyles.error} ${styles.errorColumn}`} />
              )}
            </div>
          )}
        </div>
        <div className={styles.linkContainer}>
          <div className={styles.link}>
            <Label className={styles.paymentLinkLabel} ariaLabel={t('event.create.timing.paymentLink')}>
              {t('event.create.timing.paymentLink')}{' '}
            </Label>
            <Input
              onChange={handleFeesLinkChange}
              onBlur={handleLinkBlur}
              value={feesLink.value}
              className={styles.paymentLinkInput}
              placeholder={t('event.create.timing.paymentLinkPlaceholder')}
              type='url'
            />
          </div>
          {feesLink.hasError && (
            <ErrorMessage
              text={feesLink.errorMessage}
              className={`${parentStyles.error} ${styles.error} ${styles.feesLinkError}`}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default PricingItem
